import { render, staticRenderFns } from "./merchandiseCarousel.vue?vue&type=template&id=f6b5b886&scoped=true&"
import script from "./merchandiseCarousel.vue?vue&type=script&lang=js&"
export * from "./merchandiseCarousel.vue?vue&type=script&lang=js&"
import style0 from "./merchandiseCarousel.vue?vue&type=style&index=0&id=f6b5b886&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b5b886",
  null
  
)

export default component.exports